import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseButton from '@/components/common/BaseButton.vue'

export interface Props {
  text: string;
  isDisabled?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SmallButton',
  props: {
    text: null,
    isDisabled: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseButton, {
    class: "small-button",
    text: __props.text,
    "is-disabled": __props.isDisabled,
    "is-loading": false
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["text", "is-disabled"]))
}
}

})